module.exports = __webpack_public_path__ + "static/media/token-preview-dragon.34bddb2c.png";